export interface OntologyDomainOption {
  id: string;
  label: string;
  description: string;
}

export const ONTOLOGY_BUSINESS_AREA_OPTIONS: OntologyDomainOption[] = [
  {
    id: "upstream-offshore",
    label: "Upstream Offshore",
    description: "Offshore exploration and production"
  },
  {
    id: "upstream-unconventionals",
    label: "Upstream Unconventionals",
    description: "Unconventional E&P operations"
  },
  {
    id: "midstream",
    label: "Midstream",
    description: "Midstream transport and storage"
  },
  { id: "refining", label: "Refining", description: "Refining and processing" },
  {
    id: "chemicals",
    label: "Chemicals",
    description: "Chemicals and process operations"
  },
  {
    id: "low-carbon",
    label: "Low Carbon",
    description: "Low-carbon energy and transition"
  }
];

export const DEFAULT_SELECTED_BUSINESS_AREA = "upstream-offshore";
